import React from "react";
import { __ } from "@wordpress/i18n";
import { Button } from "../button";
import { Section } from "../section";
import { getUtmUrl } from "../../utils/utm-url";

const ProPluginsBanner = ({ href = "#plans", targetBlank = false }) => {
  const gradId =
    typeof React.useId === "function"
      ? React.useId()
      : "ppb-grad-" + Math.random().toString(36).slice(2);

  const handleInstallPlugin = async () => {
    window.open(href, "_blank");
  };

  return (
    <Section className="cross-sell-pro-banner">
      <div className="cross-sell-pro-banner__inner">
        <div className="cross-sell-pro-banner__content">
          <h2>
            {__(
              "Did you know WPMU DEV Membership includes ",
              "plugin-cross-sell-textdomain"
            )}
            <span className="cross-sell-pro-banner__emph">
              {__("ALL our Pro Plugins?", "plugin-cross-sell-textdomain")}
            </span>
          </h2>

          <p>
            {__(
              "Join to unlock the full toolkit - hosting, reselling, and more.",
              "plugin-cross-sell-textdomain"
            )}
          </p>

          <Button
            as="a"
            className="cross-sell-pro-banner__cta"
            href={getUtmUrl(href, {utm_campaign:'cross-sell_pro-upsell'})}
            target={targetBlank ? "_blank" : undefined}
            rel={targetBlank ? "noopener noreferrer" : undefined}
          >
            {__("Get All Pro Plugins & More!", "plugin-cross-sell-textdomain")}

          </Button>
        </div>

        {/* Vector using SVG background */}
        <div className="cross-sell-pro-banner__vector" aria-hidden="true"></div>
      </div>
    </Section>
  );
};

export { ProPluginsBanner };
